"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Schema for Slide Progress, associated with a slideId, moduleId, and learnerId
 * @param {ObjectId} objectIdType ObjectId type from mongoose package
 * @returns Array with Collection name and defined Schema
 */
var SlideProgress = function SlideProgress(objectIdType) {
  if (!objectIdType) {
    throw new Error('objectIdType must be provided');
  }
  return ['SlideProgress', {
    _slideId: {
      type: objectIdType,
      ref: 'Slide'
    },
    slideId: {
      type: objectIdType,
      ref: 'Slide',
      required: true
    },
    moduleId: {
      type: objectIdType,
      ref: 'Module',
      required: true
    },
    learnerId: {
      type: objectIdType,
      ref: 'Learner',
      required: true
    },
    moduleProgressId: {
      type: objectIdType,
      ref: 'ModuleProgress',
      required: true
    },
    tries: {
      type: Number,
      "default": 0
    },
    started: {
      type: Date,
      required: true
    },
    correct: {
      type: Boolean
    },
    selected: [],
    elapsedTime: [{
      type: objectIdType,
      ref: 'SlideTimeStamp'
    }],
    // Used to note when a slide has been completely answered/viewed, but
    // user hasn't hit next yet
    completed: Date,
    // Used to note when a user has moved to the next slide after completing
    movedNext: Date
  }];
};
var _default = SlideProgress;
exports["default"] = _default;